import { render, staticRenderFns } from "./LogoutSubmit.vue?vue&type=template&id=4660a234&scoped=true"
import script from "./LogoutSubmit.vue?vue&type=script&lang=js"
export * from "./LogoutSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660a234",
  null
  
)

export default component.exports